// Dep 1
import Router from './routes';
import ThemeProvider from './theme';
import Settings from './components/settings';
import RtlLayout from './components/RtlLayout';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBar } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import ThemeColorPresets from './components/ThemeColorPresets';
import ThemeLocalization from './components/ThemeLocalization';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PosDrawer from './pages/dashboard/pos/components/subcomponents/mainPos/posDrawer';
import POSClose from './pages/dashboard/pos/POSClose';
import POSTransferDialog from './pages/dashboard/pos/POSTransferDialog';
import POSIncomingTransferDialog from './pages/dashboard/pos/POSIncomingTransferDialog';
import POSSessionLifecycleGuard from './pages/dashboard/pos/POSSessionLifecycleGuard';
// ----------------------------------------------------------------------

export default function App() {
  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <ThemeLocalization>
          <RtlLayout>
            <NotistackProvider>
              <MotionLazyContainer>
                <ProgressBar />
                <ChartStyle />
                <Settings />
                <ScrollToTop />
                <Router />
                <ToastContainer
                  position='top-center'
                  autoClose={false}
                  limit={500}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick={false}
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover={false}
                  theme='dark'
                />
                <PosDrawer />
                <POSClose />
                <POSTransferDialog />
                <POSIncomingTransferDialog />
                <POSSessionLifecycleGuard />
              </MotionLazyContainer>
            </NotistackProvider>
          </RtlLayout>
        </ThemeLocalization>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
